<template>
    <div>
        <DCard>
            <Form
                :errors="errors"
                :dns-template="dnsTemplate"
                :nameserver-style="nameserverStyle"
                :dns-providers="dnsProviders"
                @submit="eventUpdate"
            />
        </DCard>
    </div>
</template>

<script>
import Form from '~@/Components/Products/DNSTemplate/Form'

export default {
    name: 'DNSTemplateEdit',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        dnsTemplate: {
            type: Object,
            default () {
                return {}
            }
        },
        nameserverStyle: {
            type: Array,
            default () {
                return []
            }
        },
        dnsProviders: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        eventUpdate (form) {
            form.put(this.$route('products.dns-templates.update', {
                dns_template: this.dnsTemplate.id
            }))
        }
    }
}
</script>
